<script lang="ts" setup></script>

<template><span></span></template>

<style scoped></style>
